function system_language () {
  return {
    'ja': {
      'top_menu_title': ' For dear Guest',
      'top_menu_keeper_title': ' For HouseKeeper',
      'top_menu_title_s': '',
      'sign_out': 'サインアウト',
      'alert_yes': 'はい',
      'alert_no': 'いいえ',
      'alert_title': 'システムメッセージ',
      'err_code': 'エラーコード',
    },
    'en': {
      'top_menu_title': ' For dear Guest',
      'top_menu_keeper_title': ' For HouseKeeper',
      'top_menu_title_s': '',
      'sign_out': 'Sign out',
      'alert_yes': 'OK',
      'alert_no': 'CANCEL',
      'alert_title': 'System Messege',
      'err_code': 'Err Code',
    }
  };
}

export default new system_language();
